export const Urgent_sorcing_priority_list = [
  { id: -1, value: "Select Priority" },
  {
    id: "0",
    value: "High",
  },
  {
    id: "1",
    value: "Medium",
  },
  {
    id: "2",
    value: "Low",
  },
];
